import { injectable } from 'inversify';
import type { IPanelFacturacionRepository } from '@/domain/repositories/IPanelFacturacionRepository';
import { PanelFacturacion } from '@/domain/entities/PanelFacturacion';
import { httpClient } from '@/infrastructure/http/client/httpClient';

type PanelFacturacionApiRow = {
  id?: number;
  Id?: number;
  periodo?: string;
  Periodo?: string;
  cantidadClinicasActivas?: number;
  CantidadClinicasActivas?: number;
  cantidadClinicasNuevas?: number;
  CantidadClinicasNuevas?: number;
  cantidadClinicasDadasDeBaja?: number;
  CantidadClinicasDadasDeBaja?: number;
  cantidadClinicasQueAbonaron?: number;
  CantidadClinicasQueAbonaron?: number;
  cantidadClinicasConDeuda?: number;
  CantidadClinicasConDeuda?: number;
  dineroRecaudado?: number;
  DineroRecaudado?: number;
  dineroPendientePago?: number;
  DineroPendientePago?: number;
  fechaInicioPeriodo?: string;
  FechaInicioPeriodo?: string;
  fechaFinPeriodo?: string;
  FechaFinPeriodo?: string;
  notas?: string | null;
  Notas?: string | null;
};

function mapRow(row: PanelFacturacionApiRow): PanelFacturacion {
  const id = Number(row.id ?? row.Id ?? 0);
  const periodo = String(row.periodo ?? row.Periodo ?? '');
  const cantidadClinicasActivas = Number(row.cantidadClinicasActivas ?? row.CantidadClinicasActivas ?? 0);
  const cantidadClinicasNuevas = Number(row.cantidadClinicasNuevas ?? row.CantidadClinicasNuevas ?? 0);
  const cantidadClinicasDadasDeBaja = Number(row.cantidadClinicasDadasDeBaja ?? row.CantidadClinicasDadasDeBaja ?? 0);
  const cantidadClinicasQueAbonaron = Number(row.cantidadClinicasQueAbonaron ?? row.CantidadClinicasQueAbonaron ?? 0);
  const cantidadClinicasConDeuda = Number(row.cantidadClinicasConDeuda ?? row.CantidadClinicasConDeuda ?? 0);
  const dineroRecaudado = Number(row.dineroRecaudado ?? row.DineroRecaudado ?? 0);
  const dineroPendientePago = Number(row.dineroPendientePago ?? row.DineroPendientePago ?? 0);
  const fi = row.fechaInicioPeriodo ?? row.FechaInicioPeriodo;
  const ff = row.fechaFinPeriodo ?? row.FechaFinPeriodo;
  const notas = row.notas ?? row.Notas ?? undefined;

  return PanelFacturacion.create(
    id,
    periodo,
    cantidadClinicasActivas,
    cantidadClinicasNuevas,
    cantidadClinicasDadasDeBaja,
    cantidadClinicasQueAbonaron,
    cantidadClinicasConDeuda,
    dineroRecaudado,
    dineroPendientePago,
    new Date(fi ?? 0),
    new Date(ff ?? 0),
    notas ?? undefined
  );
}

@injectable()
export class ApiPanelFacturacionRepository implements IPanelFacturacionRepository {
  async getAll(_pageNumber?: number, _pageSize?: number): Promise<PanelFacturacion[]> {
    try {
      const response = await httpClient.get<PanelFacturacionApiRow[]>('/reports/panel-facturacion');
      const list = response.data ?? [];
      return list.map(mapRow);
    } catch (error) {
      console.error('Error fetching panel facturacion:', error);
      throw error;
    }
  }

  async getById(id: number): Promise<PanelFacturacion> {
    const all = await this.getAll();
    const panel = all.find(p => p.id === id);
    if (!panel) {
      throw new Error(`Panel facturación id ${id} no encontrado`);
    }
    return panel;
  }
}
